export const queryKey = (articleId: string, layerId?: string) => {
  const key = ['flow', articleId]
  return layerId ? [...key, layerId] : key
}
